module.exports = __webpack_public_path__ + "static/media/img_snake_head_left.17473c94.svg";